import enlang from "./en.json"
const enPackage = {
    ...enlang
}
export default enPackage
